<template>
  <template v-if="variant === variants.v1">
    <div style="position: relative">
      <library-container :key="renderKey" class="tw-relative tw-z-10 tw-px-4 tw-py-24 sm:tw-px-6 md:tw-px-0">
        <div class="tw-mb-8">
          <library-title tag="h3" :text="vars.titleText" />
        </div>

        <div
          v-for="(item, index) in items"
          :key="`client-testimonial-${index}`"
          class="tw-grid tw-grid-cols-12 tw-gap-y-8 md:tw-gap-x-16 md:tw-gap-y-0"
          :style="visibleIndex === index ? 'display: grid;' : 'display: none;'"
        >
          <div class="pxp-services-h-container tw-col-span-12 md:tw-col-span-7">
            <template v-if="vars.isPopupBool">
              <div
                class="pxp-cover pxp-animate-in tw-relative tw-z-10 tw-h-[496px] tw-w-full tw-rounded"
                :style="`background-image: url(${item.image}); `"
              >
                <div
                  style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)"
                  @click="togglePopup(true)"
                >
                  <a class="pxp-video-section-trigger tw-cursor-pointer">
                    <span class="fa fa-play"></span>
                  </a>
                </div>
              </div>
            </template>
            <template v-else>
              <iframe
                class="tw-h-[496px] tw-w-full tw-rounded"
                :src="item.video"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              />
            </template>
          </div>

          <div class="tw-col-span-12 tw-flex tw-flex-col tw-justify-end tw-gap-y-4 md:tw-col-span-5">
            <div class="tw-flex tw-gap-x-3">
              <svg
                v-for="n in item.count"
                :key="n"
                width="20"
                height="19"
                viewBox="0 0 20 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3.825 19L5.45 11.975L0 7.25L7.2 6.625L10 0L12.8 6.625L20 7.25L14.55 11.975L16.175 19L10 15.275L3.825 19Z"
                  fill="#EF787C"
                />
              </svg>
            </div>
            <h3>{{ item.title }}</h3>
            <h5>{{ item.author }}</h5>

            <div class="tw-mt-10 tw-flex tw-justify-start tw-gap-x-4 md:tw-justify-start">
              <button class="sliderNav -prev n-link" @click="goPrevOne">
                <i class="icon-left-arrow"></i>
              </button>
              <button class="sliderNav -next n-link" @click="goNextOne">
                <i class="icon-right-arrow"></i>
              </button>
            </div>
          </div>
        </div>
      </library-container>

      <div
        class="tw-absolute tw-top-0 tw-z-0 tw-mt-10 tw-h-[260px] tw-w-full md:tw-bottom-0 md:tw-left-0 md:tw-top-[unset] md:tw-h-[406px] md:tw-w-[330px] lg:tw-mt-0 lg:tw-w-[530px]"
        style="background-color: var(--purple)"
      ></div>
    </div>
  </template>

  <template v-if="variant === variants.v2">
    <section
      class="n-section-primary"
      :style="`background-color: var(--c-${vars.backgroundColor}); color: ${vars.textColor ? `var(--c-${vars.textColor})` : 'var(--c-text-primary)'}`"
    >
      <LibraryPopupsVideoPopup :videoUrl="currentVideoUrl" v-model:is-visible="isVisible" />

      <div class="tw-relative tw-flex tw-w-full tw-flex-col tw-items-center lg:tw-max-w-none">
        <div class="tw-self-start tw-text-start md:tw-self-center md:tw-text-center">
          <small v-if="vars.altTitleText">{{ vars.altTitleText }}</small>
          <h2 class="tw-mb-4 lg:tw-mb-12">{{ vars.titleText }}</h2>
        </div>
        <div class="content-container">
          <MotionGroup :preset="vars.animationText ? vars.animationText : 'popVisible'" :duration="800" is="div">
            <div class="swiper-wrapper">
              <Swiper
                :modules="[SwiperPagination]"
                @slideChange="onSlideChange"
                :pagination="false"
                :space-between="7"
                :loop="true"
                effect="fade"
                :clickable="true"
                :breakpoints="{
                  320: {
                    slidesPerView: 1,
                  },
                  1024: {
                    slidesPerView: 2,
                  },
                }"
                @swiper="onSwiper"
                class="tw-w-full"
              >
                <SwiperSlide
                  v-for="(item, index) in items"
                  :key="`singletestimonials-review-${index}`"
                  class="!tw-h-auto tw-px-2"
                >
                  <div
                    class="tw-flex tw-h-full tw-w-full tw-flex-col tw-p-8 tw-px-0 tw-duration-300 hover:tw-scale-[0.99] md:tw-px-8"
                    style="border-radius: var(--rounded)"
                  >
                    <div class="lg:tw-row tw-flex tw-h-full tw-flex-col tw-items-center tw-gap-5 tw-text-start">
                      <LibraryImage
                        v-if="item.image && !item.video"
                        :src="item.image"
                        :alt="vars.titleText"
                        class="tw-w-full"
                        :h-ratio="4.5"
                        :w-ratio="7"
                        style="border-radius: var(--rounded-sm)"
                      />
                      <div
                        v-if="item.image && item.video"
                        class="tw-relative tw-w-full"
                        @click="((isVisible = true), (currentVideoUrl = item.video))"
                      >
                        <LibraryImage
                          :src="item.image"
                          :alt="vars.titleText"
                          image-class="tw-w-full tw-cursor-pointer"
                          :h-ratio="4.5"
                          :w-ratio="7"
                          style="border-radius: var(--rounded-sm)"
                        />
                        <button class="tw-absolute tw-left-1/2 tw-top-1/2 -tw-translate-x-1/2 -tw-translate-y-1/2">
                          <svg
                            width="64"
                            height="64"
                            viewBox="0 0 36 36"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M18 0C22.7739 0 27.3523 1.89642 30.7279 5.27208C34.1036 8.64773 36 13.2261 36 18C36 22.7739 34.1036 27.3523 30.7279 30.7279C27.3523 34.1036 22.7739 36 18 36C13.2261 36 8.64773 34.1036 5.27208 30.7279C1.89642 27.3523 0 22.7739 0 18C0 13.2261 1.89642 8.64773 5.27208 5.27208C8.64773 1.89642 13.2261 0 18 0ZM3.375 18C3.375 21.8788 4.91584 25.5987 7.65856 28.3414C10.4013 31.0842 14.1212 32.625 18 32.625C21.8788 32.625 25.5987 31.0842 28.3414 28.3414C31.0842 25.5987 32.625 21.8788 32.625 18C32.625 14.1212 31.0842 10.4013 28.3414 7.65856C25.5987 4.91584 21.8788 3.375 18 3.375C14.1212 3.375 10.4013 4.91584 7.65856 7.65856C4.91584 10.4013 3.375 14.1212 3.375 18ZM14.3528 11.7608L23.9467 17.5185C24.0297 17.5686 24.0982 17.6392 24.1458 17.7236C24.1934 17.8079 24.2185 17.9031 24.2185 18C24.2185 18.0969 24.1934 18.1921 24.1458 18.2764C24.0982 18.3608 24.0297 18.4314 23.9467 18.4815L14.3528 24.2393C14.2674 24.2906 14.17 24.3185 14.0704 24.3199C13.9708 24.3213 13.8727 24.2962 13.7859 24.2472C13.6992 24.1983 13.627 24.1271 13.5768 24.0411C13.5266 23.9551 13.5001 23.8573 13.5 23.7577V12.2445C13.4997 12.1447 13.5259 12.0466 13.5759 11.9603C13.626 11.874 13.6982 11.8026 13.7849 11.7533C13.8717 11.7041 13.9701 11.6788 14.0699 11.6801C14.1696 11.6814 14.2673 11.7093 14.3528 11.7608Z"
                              fill="white"
                            />
                          </svg>
                        </button>
                      </div>

                      <div
                        v-if="!item.image && item.video"
                        class="tw-relative tw-w-full"
                        @click="((isVisible = true), (currentVideoUrl = item.video))"
                      >
                        <library-iframe :src="item.video" />
                      </div>
                      <div class="tw-flex tw-h-full tw-flex-col tw-gap-4">
                        <div class="tw-flex tw-flex-col tw-gap-1">
                          <div class="tw-mt-4 tw-flex tw-items-center tw-gap-2">
                            <svg
                              v-for="n in item.count"
                              :key="`singletestimonials-star-${n}`"
                              width="32"
                              height="32"
                              viewBox="0 0 20 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M10 1.25L12.472 7.5H19L13.764 10.972L15.236 17.5L10 13.444L4.764 17.5L6.236 10.972L1 7.5H7.528L10 1.25Z"
                                fill="var(--c-primary)"
                              />
                            </svg>
                          </div>
                          <h4 class="tw-mt-2">{{ item.title }}</h4>
                        </div>
                        <div class="tw-flex tw-max-h-60 tw-flex-col tw-gap-2 tw-overflow-y-auto xl:tw-max-h-80">
                          <p>{{ item.description }}</p>
                        </div>
                        <h5 class="n-semibold tw-mt-auto">{{ item.author }}</h5>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              </Swiper>
            </div>
          </MotionGroup>
        </div>
        <div v-if="items.length > 2" class="tw-hidden lg:tw-block">
          <LibrarySliderPagination
            :swiper="swiper"
            variant="v9"
            :can-paginate-back="canPaginateBack"
            :can-paginate-next="canPaginateNext"
            :variables="vars"
          />
        </div>
        <div v-if="items.length > 1" class="tw-block lg:tw-hidden">
          <LibrarySliderPagination
            :swiper="swiper"
            variant="v9"
            :can-paginate-back="canPaginateBack"
            :can-paginate-next="canPaginateNext"
            :variables="vars"
          />
        </div>
      </div>
    </section>
  </template>

  <template v-if="variant === variants.v3">
    <section
      class="layout-pt-lg layout-pb-lg tw-overflow-hidden"
      :style="`background-color: var(--c-${vars.backgroundColor});`"
    >
      <BlockSymbol
        v-if="vars.watermarkImage"
        :block-logo-image="String(vars.watermarkImage)"
        :block-opacity="Number(vars?.watermarkOpacityNumber || 1)"
        position-text="right_bottom"
        :company-key="company.company_key"
      />
      <div class="tw-w-full">
        <div class="tw-mb-16 tw-flex tw-flex-col tw-items-center tw-self-center tw-text-center">
          <h2>{{ vars.titleText }}</h2>
        </div>
        <div class="tw-w-full !tw-text-white">
          <Swiper
            @slideChange="onSlideChange"
            @swiper="onSwiper"
            :pagination="false"
            :centered-slides="true"
            :space-between="15"
            effect="fade"
            :loop="true"
            :clickable="true"
            :breakpoints="{
              320: { slidesPerView: 2, spaceBetween: 20, centeredSlides: true },
              640: { slidesPerView: 3, spaceBetween: 20, centeredSlides: true },
              768: { slidesPerView: 3, spaceBetween: 20, centeredSlides: true },
              1024: { slidesPerView: 5, spaceBetween: 30, centeredSlides: false, centerInsufficientSlides: true },
              1536: { slidesPerView: 7, spaceBetween: 40, centeredSlides: false, centerInsufficientSlides: true },
            }"
            class="social-swiper tw-w-full tw-self-start"
          >
            <SwiperSlide v-for="(item, index) in items" :key="`video-testimonial-${index}`">
              <div
                class="no-hover shine-effect tw-group tw-relative tw-basis-1/3 tw-overflow-hidden tw-transition-all tw-duration-500 hover:tw-cursor-pointer"
              >
                <div class="tw-relative tw-aspect-[9/16] tw-w-full">
                  <library-iframe :src="item.video" :h-ratio="16" :w-ratio="9"></library-iframe>
                </div>
              </div>
            </SwiperSlide>
          </Swiper>
          <div class="mt-60 md:mt-30 tw-flex tw-items-center tw-justify-center">
            <button
              @click="swiper.slidePrev()"
              class="sliderNav n-link !tw-bg-transparent !tw-text-white"
              style="border-color: #8fbb54 !important"
            >
              <i class="icon-left-arrow"></i>
            </button>
            <button
              @click="swiper.slideNext()"
              class="sliderNav ml-20 n-link !tw-bg-transparent !tw-text-white"
              style="border-color: #8fbb54 !important"
            >
              <i class="icon-right-arrow"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  </template>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';
import { produceKey } from '~/server/core/helpers';
import { jQuery } from 'public/theme3/js/custom';
import Popup from '~/components/common/popup/Popup.vue';
import BlockSymbol from '~/components/common/BlockSymbol.vue';

export default defineNuxtComponent({
  name: 'VideoTestimonials',
  components: { Popup, BlockSymbol },
  mixins: [ComponentMixin],

  data() {
    return {
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
      },
      // v1 popup state
      isPopupVisible: false,
      // v2 popup state
      isVisible: false,
      currentVideoUrl: '',
      // shared navigation state
      visibleIndex: 0,
      swiper: null,
      canPaginateBack: true,
      canPaginateNext: true,
      renderKey: produceKey(),
      selectedItem: null,
      popupConfig: {
        isActive: false,
      },
      // v3 inline playback index
      playingIndex: null as number | null,
    };
  },

  mounted() {
    this.onSlideChange();
  },

  computed: {
    visibleTestimonial() {
      return this.items[this.visibleIndex];
    },
    items() {
      return this.groupedVariables.items;
    },
  },

  methods: {
    // v1 controls
    togglePopup(status = false) {
      this.isPopupVisible = status;
    },
    openPopup(item: any = null, value = false) {
      if (item) {
        this.selectedItem = item;
        this.popupConfig.isActive = value;
      }
    },

    // shared hover-play for v3 thumbnails
    playVideo(event: MouseEvent) {
      const video = (event.currentTarget as HTMLElement).closest('.tw-group')?.querySelector('video');
      if (video) (video as HTMLVideoElement).play();
    },
    pauseVideo(event: MouseEvent) {
      const video = (event.currentTarget as HTMLElement).closest('.tw-group')?.querySelector('video');
      if (video) {
        const v = video as HTMLVideoElement;
        v.pause();
        v.currentTime = 0;
      }
    },

    // v1 pagination
    goNextOne() {
      if (this.items.length !== this.visibleIndex + 1) {
        this.visibleIndex += 1;
      } else {
        this.visibleIndex = 0;
      }
      this.renderKey = produceKey();
      this.$nextTick(() => {
        jQuery.runAnimation();
      });
    },
    goPrevOne() {
      if (this.visibleIndex > 0) {
        this.visibleIndex -= 1;
      } else {
        this.visibleIndex = this.items.length - 1;
      }
      this.renderKey = produceKey();
      this.$nextTick(() => {
        jQuery.runAnimation();
      });
    },

    // swiper integration
    onSwiper(swiperInstance: any) {
      this.swiper = swiperInstance;
    },
    onSlideChange() {
      if (!this.swiper) return;
      this.canPaginateBack = !this.swiper.isBeginning;
      this.canPaginateNext = !this.swiper.isEnd;
    },
  },
});
</script>

<style scoped>
/* Centered slides için özel stil */
.social-wall-swiper {
  overflow: visible !important;
}

.social-wall-swiper :deep(.swiper-wrapper) {
  align-items: center;
}

.social-wall-swiper :deep(.swiper-slide) {
  width: 200px !important;
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  opacity: 0.6;
}

/* Merkezdeki aktif slide */
::v-deep(.swiper-slide) {
  transition: all 0.3s;
}

::v-deep(.swiper-slide-active) {
  transform: scale(1.1);
}

::v-deep(.swiper) {
  overflow: unset !important;
}

.social-wall-swiper :deep(.swiper-slide-active) > div {
  transform: scale(1.25);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
}

.sliderNav:hover {
  background-color: #8fbb54 !important;
  color: #fff !important;
}
.sliderNav:hover i {
  color: #fff !important;
}
/* Aktif kart için sürekli shine efekti */
.social-wall-swiper :deep(.swiper-slide-active) .shine {
  opacity: 0.2 !important;
  animation: shine-animation 3s infinite;
}

@keyframes shine-animation {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

/* Shine efekti için gradient */
.shine::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(45deg, transparent 30%, rgba(255, 255, 255, 0.3) 50%, transparent 70%);
  transform: rotate(45deg);
}

/* Responsive düzenlemeler */
@media (max-width: 1024px) {
  .social-wall-swiper :deep(.swiper-slide) {
    width: 150px !important;
  }

  .social-wall-swiper :deep(.swiper-slide-active) {
    width: 180px !important;
  }

  .social-wall-swiper :deep(.swiper-slide-active) > div {
    transform: scale(1.2);
  }
}

/* Orijinal stiller aynen korundu */
@media (hover: none) {
  .no-hover .shine-effect {
    filter: none;
  }

  .no-hover .shine {
    opacity: 20%;
  }

  .no-hover .card-icon-v1 {
    opacity: 100%;
    pointer-events: auto;
    transform: translateY(0px);
  }
}

@media (min-width: 700px) and (max-width: 1400px) {
  ::v-deep(.pm-modal-wrapper) {
    width: 95% !important;
  }
}

@media (min-width: 1401px) {
  ::v-deep(.pm-modal-wrapper) {
    width: 60% !important;
  }
}
</style>
